import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Light from 'components/headers/light';
import axios from 'axios';
import Swal from 'sweetalert2';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import { useTranslation } from 'react-i18next';

const Profile = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState({
    name: '',
    address: '',
    email: '',
    phone: ''
  });
  const [role, setRole] = useState('');

  const [formData, setFormData] = useState(userInfo);
  const token = localStorage.getItem('authToken');
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();  // Use navigate hook for redirection

  useEffect(() => {
    if (!token) {
      Swal.fire('Erreur', 'Vous devez être connecté pour accéder à votre profil.', 'error');
      navigate('/login');
      return;
    }

    fetchAllUserInfo();
    const userRole = localStorage.getItem('role');
    setRole(userRole); 
  }, [token, navigate]);

  useEffect(() => {
    setFormData(userInfo);
  }, [userInfo]);

  const fetchAllUserInfo = async () => {
    try {
      const userId = user?.id;
      if (!token || !userId) return;

      const response = await axios.get(`  https://rehabwmg.online/api/suppliers/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        setUserInfo(response.data);
      }
     } catch (error) {
  if (error.response?.status === 403) {
    // Clear auth and redirect to login
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    Swal.fire("Compte non vérifié", error.response.data.message, "warning").then(() => {
      navigate("/login");
    });
  } else if (error.response?.status === 401) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("role");
    Swal.fire("Unauthorized", "Please log in again.", "error").then(() => {
      navigate("/login");
    });
  } else {
    Swal.fire("Error", "Something went wrong.", "error");
  }
}};

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSaveChanges = async () => {
    try {
      if (!token) return;

      const response = await axios.put(
        '  https://rehabwmg.online/api/user/update',
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Mise à jour réussie',
          text: 'Vos informations ont été mises à jour avec succès!',
          confirmButtonText: 'OK'
        }).then(() => {
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          navigate('/login');  // Redirect to the login page
        });
      }
    } catch (error) {
      console.error('Error updating user info:', error);
    }
  };

  return (
    <AnimationRevealPage>
      {/* Conditionally render Light or LightBuyer based on user role */}
      {role === 'supplier' ? <Light /> : <Light />}
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="container w-100 w-md-75 p-5"> {/* Adjusted padding for spacious design */}
          <div className="card shadow-lg" style={{ borderRadius: '15px', border: 'none' }}>
            <div className="card-header text-center fs-4" style={{ backgroundColor: '#4e7662', color: 'white', borderRadius: '15px 15px 0 0' }}>
              <strong>{t('Details_compte')}</strong>
            </div>
            <div className="card-body">
              <form>
                <div className="mb-4">
                  <label className="form-label text-muted" htmlFor="name">{t('Nom_Complet')}</label>
                  <input 
  className="form-control form-control-lg" 
  id="name" 
  type="text" 
  value={formData.name} 
  onChange={handleInputChange} 
  placeholder= {t('Nom_Complet')}
  style={{ backgroundColor: '#f1f1f1', borderRadius: '10px', padding: '10px' }}
  disabled // This will disable the input
/>

                </div>
                <div className="mb-4">
                  <label className="form-label text-muted" htmlFor="email">{t('Email')}</label>
                  <input 
                    className="form-control form-control-lg" 
                    id="email" 
                    type="email" 
                    value={formData.email} 
                    onChange={handleInputChange} 
                    placeholder={t('Email')} 
                    style={{ backgroundColor: '#f1f1f1', borderRadius: '10px', padding: '10px' }}
                  />
                </div>
                <div className="row gx-3 mb-4">
                  <div className="col-12 col-md-6">
                    <label className="form-label text-muted" htmlFor="phone">{t('Numéro_de_Téléphone')}</label>
                    <input 
                      className="form-control form-control-lg" 
                      id="phone" 
                      type="tel" 
                      value={formData.phone} 
                      onChange={handleInputChange} 
                      placeholder="Votre numéro de téléphone" 
                      style={{ backgroundColor: '#f1f1f1', borderRadius: '10px', padding: '10px' }}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label text-muted" htmlFor="address">{t('Adresse')}</label>
                    <input 
                      className="form-control form-control-lg" 
                      id="address" 
                      type="text" 
                      value={formData.address} 
                      onChange={handleInputChange} 
                      placeholder="Votre adresse" 
                      style={{ backgroundColor: '#f1f1f1', borderRadius: '10px', padding: '10px' }}
                    />
                  </div>
                </div>
                <button 
                  className="btn w-100" 
                  style={{
                    backgroundColor: '#4e7662', 
                    color: 'white', 
                    border: 'none', 
                    padding: '12px',
                    borderRadius: '10px', 
                    fontWeight: 'bold', 
                    transition: 'all 0.3s ease-in-out'
                  }}
                  type="button" 
                  onClick={handleSaveChanges}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#d87bb3'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#4e7662'}
                >
                  {t('Sauvegarder')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AnimationRevealPage>
  );
};

export default Profile;
